<template>
  <div class="m-badge">
    <div class="chat-icon">
      <el-badge v-if="imUnreadCount > 0 && moduleName === 'chat'" :value="imUnreadCount" class="item">
        <i style="font-size: 24px" :class="activeName === moduleName ? icon : unActiveIcon" @click="handleActive"></i>
      </el-badge>
      <i v-else style="font-size: 24px" :class="activeName === moduleName ? icon : unActiveIcon" @click="handleActive"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SidebarModule',
  props: {
    moduleName: {
      type: String,
      default: 'chat'
    },
    icon: {
      type: String,
      default: 'ukfont youkai-fill-new-communication-message-chat-round module-active'
    },
    unActiveIcon: {
      type: String,
      default: 'ukfont youkai-chat-round'
    },
    activeName: {
      type: String,
      default: 'chat'
    }
  },
  computed: {
    ...mapState({
      imUnreadCount: state => state.imUnreadCount
    })
  },
  methods: {
    handleActive () {
      this.$emit('handleActive', this.moduleName)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .m-badge {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, .85);
    font-size: 14px;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnim";
    position: relative;
    display: inline-block;
  }
  .chat-icon {
    margin: 0 0 25px;
    font-size: 22px;
    color: rgba(0, 0, 0, .6);
    //height: 45px;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  .module-active {
    color: #4d84fe;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/leftSidebar/SidebarModule.vue